import { createTheme, Input, Title } from "@mantine/core";
import { generateColors } from "@mantine/colors-generator";

import classes from "./mantineTheme.module.scss";

const mantineTheme = createTheme({
    fontFamily: "Roboto, sans-serif",
    colors: {
        primary: generateColors("#00447A"),
        secondary: generateColors("#fea002"),
        information: generateColors("#29b6f6"),
        warning: generateColors("#ffa726"),
        success: generateColors("#66bb6a"),
        error: generateColors("#f44336"),

        "ngt-form-description": generateColors("#2e2e2e"),
        "ngt-form-information": generateColors("#228be6"),
        "ngt-form-warning": generateColors("#fab005"),
        "ngt-form-low": generateColors("#ca5252"),
        "ngt-form-medium": generateColors("#da5252"),
        "ngt-form-high": generateColors("#ea5252"),
        "ngt-form-critical": generateColors("#fa5252"),
    },
    primaryColor: "primary",
    primaryShade: 9,
    breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em",
    },
    components: {
        Container: {
            vars: () => ({
                root: {
                    "--container-size-xl": "calc(88rem * var(--mantine-scale))",
                },
            }),
        },
        Input: Input.extend({
            classNames: {
                input: classes.disabledInput,
            },
        }),
        Title: Title.extend({
            defaultProps: {
                c: "primary",
            },
        }),
    },
    fontWeights: {
        medium: "400",
    },
    headings: {
        fontWeight: "400",
    },
});

export default mantineTheme;
